const EPauseGameBtnStates = {
    resumeGame: 1,
    exitGame: 2
}

const EGameGoalBtnStates = {
    tapToPlay: 1,
    exitGame: 2
}
function getBaseUrl() {
    return window.POPUPS_BASE_URL || API_URL;
}

function getPopupByName(popupName) {
    // Р¤РѕСЂРјРёСЂСѓРµРј РїСѓС‚СЊ Рє С„Р°Р№Р»Сѓ
    //https://d43xjjq7uepv7.cloudfront.net/general-popups/
    var filePath = getBaseUrl() + popupName + '.html';
    // var filePath = './' + popupName + '.html';

    // РЎРѕР·РґР°РµРј Р·Р°РїСЂРѕСЃ РґР»СЏ Р·Р°РіСЂСѓР·РєРё С„Р°Р№Р»Р°
    var xhr = new XMLHttpRequest();
    xhr.open('GET', filePath, false); // РЎРёРЅС…СЂРѕРЅРЅС‹Р№ Р·Р°РїСЂРѕСЃ
    xhr.send();

    // РџСЂРѕРІРµСЂСЏРµРј СЃС‚Р°С‚СѓСЃ Р·Р°РїСЂРѕСЃР°
    if (xhr.status === 200) {
        // Р’РѕР·РІСЂР°С‰Р°РµРј СЃРѕРґРµСЂР¶РёРјРѕРµ С„Р°Р№Р»Р°
        return xhr.responseText;
    } else {
        // Р•СЃР»Рё РїСЂРѕРёР·РѕС€Р»Р° РѕС€РёР±РєР°, РІС‹РІРѕРґРёРј СЃРѕРѕР±С‰РµРЅРёРµ
        console.error('Failed to load popup content.');
        return null;
    }
}

// используется (match, bubble, 2d)
window.getMissingWebGLPopup = function (locObject) {
    const popup = getPopupByName('missing-webgl');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = popup;

    if (tempDiv.querySelector('.play-again-btn')) {
        tempDiv.querySelector('.play-again-btn').addEventListener(('pointerup'), () => {
            const customEvent = new CustomEvent('play-again-btn-clicked');
            window.dispatchEvent(customEvent)
        })
    }

    if (locObject && locObject['missing-webgl-description']) {
        tempDiv.querySelector('#modal__text').textContent = locObject['missing-webgl-description'];
    }
    if (locObject && locObject['missing-webgl-title']) {
        tempDiv.querySelector('#modal__title').innerHTML = locObject['missing-webgl-title'];
    }
    // if (locObject && locObject['bad-internet-btn']) {
    //     tempDiv.querySelector('#play-again-btn').innerHTML = locObject['bad-internet-btn'];
    // }

    return tempDiv;
}

// используется (match, bubble, 2d)
window.getBadInternetPopup = function (locObject) {
    let isOnline = true;
    const popup = getPopupByName('bad-internet');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = popup;

    window.addEventListener('online', () => {
        isOnline = true;
    });
    
    window.addEventListener('offline', () => {
        isOnline = false;
    });

    if (locObject && locObject['bad-internet-title']) {
        tempDiv.querySelector('#modal__title').innerHTML = locObject['bad-internet-title'];
    }
    if (locObject && locObject['bad-internet-description']) {
        tempDiv.querySelector('#modal__text').textContent = locObject['bad-internet-description'];
    }
    if (locObject && locObject['bad-internet-btn']) {
        tempDiv.querySelector('#error-btn').textContent = locObject['bad-internet-btn'];
    }

    const btnPlayAgain = tempDiv.querySelector('#error-btn');
    const badinternetReloadEvent = new CustomEvent('badinternet-reload-event');
    btnPlayAgain.addEventListener("pointerup", async (e) => {
        if (isOnline) {
            window.dispatchEvent(badinternetReloadEvent);
        } else {
            btnPlayAgain.disabled = true;
            if (locObject && locObject['bad-internet-checking-connection']) {
                tempDiv.querySelector('#error-btn').textContent = locObject['bad-internet-checking-connection'];
            }
            setTimeout(() => {
                btnPlayAgain.disabled = false;
                if (locObject && locObject['bad-internet-btn']) {
                    tempDiv.querySelector('#error-btn').textContent = locObject['bad-internet-btn'];
                }
            }, 2000)
        }
    });


    return tempDiv;
}

// 
window.getPausePopup = function (data) {
    console.log('getPausePopup');
    
    // data keys: 
    // scoreToCollect: number
    // targetText: string
    // currentScore: number
    // isPreview: boolean
    // targets: {url: string, amount: number, target: number}[] = urls for targets in Collect colors target
    // destroyOrders: {urls: string[], target: number} = target for 2d shooter
    if (!data) {
        throw new Error('Parameter required');
    }

    if (!data.btnState) {
        data.btnState = EPauseGameBtnStates['resumeGame'];
    }

    if (!data.currentScore) {
        data.currentScore = 0;
    }

    if (!data.targets && !data.destroyOrders && typeof data.currentScore === 'undefined') {
        throw new Error('"currentScore" or "targets" or "destroyOrders" is required');
    }

    if (!data.targetText) {
        throw new Error('"targetText" is required');
    }

    if (!data.targets) {
        data.targets = [];
    }

    if (data && !Array.isArray(data.targets)) {
        throw new Error('Targets must be an array');
    }

    if (data && data.targets.length > 5) {
        throw new Error('Targets must not exceed a length of 5');
    }

    if (data && data.targets.length > 0) {
        for (const target of data.targets) {
            // Check if each element is an object
            if (typeof target !== 'object' || target === null || Array.isArray(target)) {
                throw new Error('Each element in targets must be an object');
            }

            // Check if the object contains required fields: url (string) and amount (number)
            if (typeof target.url !== 'string' || typeof target.amount !== 'number' || typeof target.target !== 'number') {
                throw new Error('Each object in targets must contain fields url (string) and amount (number) and target (number)');
            }
        }
    }
    if (data && data.destroyOrders) {
        if (!Array.isArray(data.destroyOrders.urls) || typeof data.destroyOrders.target !== 'number') {
            throw new Error('Each object in targets must contain fields urls (string array) and target (number)');
        }
    }

    if (data && !data.gameGoalTitle) {
        data.gameGoalTitle = 'Get the highest score';
    }

    const popup = getPopupByName('pause');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = popup;
    if (popup && data.targetName) {
        const targetNameEl = tempDiv.getElementsByClassName('pause-text')[0];
        targetNameEl.textContent = data.targetName;
    }

    if (popup && data.targets.length === 0 && data.scoreToCollect > 0 && !data.destroyOrders) {
        tempDiv.getElementsByClassName('score-to-collect')[0].style.display = 'block';
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'none';
        tempDiv.getElementsByClassName('targets')[0].style.display = 'none';

        tempDiv.getElementsByClassName('score')[0].textContent = data.currentScore;
        tempDiv.getElementsByClassName('goal-score')[0].textContent = data.scoreToCollect;
    } else if (data.targets.length > 0) {
        tempDiv.getElementsByClassName('score-to-collect')[0].style.display = 'none';
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'none';
        tempDiv.getElementsByClassName('targets')[0].style.display = 'block';
    } else if (data.destroyOrders) {
        tempDiv.getElementsByClassName('score-to-collect')[0].style.display = 'none';
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'block';
        tempDiv.getElementsByClassName('targets')[0].style.display = 'none';
    }

    if (popup && data.targets.length > 0) {
        // tempDiv.querySelector('.goal-state-3-title').classList.remove('hidden');
        tempDiv.getElementsByClassName('targets')[0].style.display = 'block';
        const targetDiv = tempDiv.getElementsByClassName('tiles-task')[0];

        const targetEl = targetDiv && targetDiv.getElementsByClassName('tile')[0];
        if (targetEl) {
            let duplicatedContent = '';
            for (let i = 0; i < data.targets.length; i++) {
                const newTarget = targetEl.cloneNode(true);
                const taskItemEl = newTarget.getElementsByClassName('task-item')[0];
                const amountEl = newTarget.getElementsByClassName('points-frame-amount')[0];
                const targetValueEl = newTarget.getElementsByClassName('points-frame-target')[0];
                if (taskItemEl) {
                    taskItemEl.src = data.targets[i].url;
                }
                if (amountEl) {
                    amountEl.textContent = data.targets[i].amount;
                }
                if (targetValueEl) {
                    targetValueEl.textContent = data.targets[i].target;
                }
                duplicatedContent += newTarget.outerHTML;
            }

            targetDiv.innerHTML = duplicatedContent;
        }

    } else if (popup && data.destroyOrders) {
        const targetDiv = tempDiv.getElementsByClassName('destroy-targets')[0].getElementsByClassName('tiles-task')[0];
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'block';
        const points = tempDiv.getElementsByClassName('destroy-targets')[0].getElementsByClassName('points-frame')[0];
        if (points) {
            points.textContent = data.destroyOrders.target;
        }
        const targetEl = targetDiv && targetDiv.getElementsByClassName('tile')[0];
        if (targetEl) {
            let duplicatedContent = '';
            for (let i = 0; i < data.destroyOrders.urls.length; i++) {
                const newTarget = targetEl.cloneNode(true);
                const taskItemEl = newTarget.getElementsByClassName('task-item')[0];
                if (taskItemEl) {
                    taskItemEl.src = data.destroyOrders.urls[i];
                }
                duplicatedContent += newTarget.outerHTML;
            }
            if (points) {
                duplicatedContent += points.outerHTML;
            }
            targetDiv.innerHTML = duplicatedContent;
        }
    } else {
        tempDiv.getElementsByClassName('targets')[0].style.display = 'none';
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'none';
        const tileTasks = tempDiv.getElementsByClassName('tiles-task');
        for (let i = 0; i < tileTasks.length; i++) {
            tileTasks[i].style.display = 'none';
        }
    }
    tempDiv.getElementsByClassName('pause-text')[0].textContent = data.targetText;

    const exitBtn = tempDiv.querySelector('#exit-game');
    const playAgainBtn = tempDiv.querySelector('#play-again');
    const awareText = tempDiv.querySelector('.aware');
    if (data.isPreview) {
        exitBtn.style.display = 'none';
        playAgainBtn.style.display = 'block';
        awareText.style.display = 'none';
    } else {
        exitBtn.style.display = 'block';
        playAgainBtn.style.display = 'none';
        awareText.style.display = 'block';
    }

    const btnPlayAgain = tempDiv.querySelector('#' + 'play-again');
    btnPlayAgain.classList.remove('hidden');
    const playAgainCustomEvent = new CustomEvent('play-again-btn-clicked');
    btnPlayAgain.addEventListener("pointerup", (e) => {
        window.dispatchEvent(playAgainCustomEvent)
        tempDiv.parentElement.removeChild(tempDiv);
    });

    const btnExit = tempDiv.querySelector('#' + 'exit-game');
    btnExit.classList.remove('hidden');
    const exitCustomEvent = new CustomEvent('exit-btn-clicked');
    btnExit.addEventListener("pointerup", (e) => {
        window.dispatchEvent(exitCustomEvent)
        tempDiv.parentElement.removeChild(tempDiv);
    });

    const btnResume = tempDiv.querySelector('#' + 'resume-game');
    btnResume.classList.remove('hidden');
    const resumeCustomEvent = new CustomEvent('resume-btn-clicked');
    btnResume.addEventListener("pointerup", (e) => {
        window.dispatchEvent(resumeCustomEvent)
    });

    document.body.appendChild(tempDiv)

    return tempDiv;
}

// используется (match, bubble, 2d)
window.getGameGoalPopup = function (data, locObject) {
    // data keys: 
    // gameName: string = game nage
    // gameIcon?: string = game icon (optional)
    // targetText: string
    // scoreToCollect: number
    // targets: {url: string, target: number}[] = urls for targets in Collect colors target
    // destroyOrders: {urls: string[], target: number} = target for 2d shooter
    // quiz: boolean | object = goal for quiz game (question mark icon + targetText)
    if (!data) {
        throw new Error('Parameter required');
    }

    if (!data.btnState) {
        data.btnState = EGameGoalBtnStates['resumeGame'];
    }

    if (!data.targets && !data.scoreToCollect && !data.destroyOrders && !data.quiz) {
        throw new Error('"scoreToCollect" or "targets" or "destroyOrders" or "quiz" is required');
    }

    if (!data.gameName) {
        throw new Error('"gameName" is required');
    }

    if (!data.targetText && !data.quiz) {
        throw new Error('"targetText" is required');
    }

    if (!data.targetText) {
        data.targetText = '';
    }

    if (!data.targets) {
        data.targets = [];
    }

    if (data && !Array.isArray(data.targets)) {
        throw new Error('Targets must be an array');
    }

    if (data && data.targets.length > 5) {
        throw new Error('Targets must not exceed a length of 5');
    }

    if (data && data.targets.length > 0) {
        for (const target of data.targets) {
            // Check if each element is an object
            if (typeof target !== 'object' || target === null || Array.isArray(target)) {
                throw new Error('Each element in targets must be an object');
            }

            // Check if the object contains required fields: url (string) and target (number)
            if (typeof target.url !== 'string' || typeof target.target !== 'number') {
                throw new Error('Each object in targets must contain fields url (string) and target (number)');
            }
        }
    }
    if (data && data.destroyOrders) {
        if (!Array.isArray(data.destroyOrders.urls) || typeof data.destroyOrders.target !== 'number') {
            throw new Error('Each object in targets must contain fields urls (string array) and target (number)');
        }
    }

    
    const popup = getPopupByName('game-goal');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = popup;
    const gameIconEl = tempDiv.querySelector('#game_icon');
    if (popup && data.gameIcon && gameIconEl) {
        gameIconEl.src = data.gameIcon;
    }

    const gameNameEl = tempDiv.getElementsByClassName('long-game-name')[0];
    if (gameNameEl) {
        gameNameEl.textContent = data.gameName;
    }

    if (popup && data.quiz) {
        tempDiv.getElementsByClassName('score-container')[0].style.display = 'none';
        tempDiv.getElementsByClassName('targets')[0].style.display = 'none';
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'none';

        const quizEl = tempDiv.getElementsByClassName('quiz-goal')[0];
        if (quizEl) {
            quizEl.style.display = 'block';

            const quizIconEl = quizEl.getElementsByClassName('quiz-goal-icon')[0];
            if (quizIconEl) {
                quizIconEl.src = getBaseUrl() + 'assets/img/quiz-question.png';
            }
        }
    } else if (popup && data.targets.length === 0 && data.scoreToCollect > 0 && !data.destroyOrders) {
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'none';
        tempDiv.getElementsByClassName('targets')[0].style.display = 'none';
        const pointsTaskEl = tempDiv.getElementsByClassName('points-task')[0];
        if (pointsTaskEl) {
            pointsTaskEl.textContent = data.scoreToCollect;
        }
    } else if (popup && data.targets.length > 0) {
        tempDiv.getElementsByClassName('score-container')[0].style.display = 'none';
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'none';
    } else if (popup && data.destroyOrders) {
        tempDiv.getElementsByClassName('score-container')[0].style.display = 'none';
        tempDiv.getElementsByClassName('targets')[0].style.display = 'none';
    }

    if (popup && data.targets.length > 0 && !data.destroyOrders) {
        // tempDiv.querySelector('.goal-state-3-title').classList.remove('hidden');
        const targetDiv = tempDiv.getElementsByClassName('tiles-task')[0];
        tempDiv.getElementsByClassName('targets')[0].style.display = 'block';

        const targetEl = targetDiv && targetDiv.getElementsByClassName('tile')[0];
        if (targetEl) {
            let duplicatedContent = '';
            for (let i = 0; i < data.targets.length; i++) {
                const newTarget = targetEl.cloneNode(true);
                const taskItemEl = newTarget.getElementsByClassName('task-item')[0];
                const pointsFrameEl = newTarget.getElementsByClassName('points-frame')[0];
                if (taskItemEl) {
                    taskItemEl.src = data.targets[i].url;
                }
                if (pointsFrameEl) {
                    pointsFrameEl.textContent = data.targets[i].target;
                }
                duplicatedContent += newTarget.outerHTML;
            }

            targetDiv.innerHTML = duplicatedContent;
        }

    } else if (data.destroyOrders) {
        const targetDiv = tempDiv.getElementsByClassName('destroy-targets')[0].getElementsByClassName('tiles-task')[0];
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'block';
        const points = tempDiv.getElementsByClassName('destroy-targets')[0].getElementsByClassName('points-frame')[0];
        if (points) {
            points.textContent = data.destroyOrders.target;
        }
        const targetEl = targetDiv && targetDiv.getElementsByClassName('tile')[0];
        if (targetEl) {
            let duplicatedContent = '';
            for (let i = 0; i < data.destroyOrders.urls.length; i++) {
                const newTarget = targetEl.cloneNode(true);
                const taskItemEl = newTarget.getElementsByClassName('task-item')[0];
                if (taskItemEl) {
                    taskItemEl.src = data.destroyOrders.urls[i];
                }
                duplicatedContent += newTarget.outerHTML;
            }
            if (points) {
                duplicatedContent += points.outerHTML;
            }
            targetDiv.innerHTML = duplicatedContent;
        }
    } else {
        tempDiv.getElementsByClassName('targets')[0].style.display = 'none';
        tempDiv.getElementsByClassName('destroy-targets')[0].style.display = 'none';
        const tileTasks = tempDiv.getElementsByClassName('tiles-task');
        for (let i = 0; i < tileTasks.length; i++) {
            tileTasks[i].style.display = 'none';
        }
    }

    for (let i = 0; i < tempDiv.getElementsByClassName('target-description').length; i++) {
        tempDiv.getElementsByClassName('target-description')[i].textContent = data.targetText;
    }

    if (data.quiz && tempDiv.querySelector('.quiz-goal .target-description')) {
        tempDiv.querySelector('.quiz-goal .target-description').textContent = 'Answer the questions';
    }

    const playBtn = tempDiv.querySelector('#' + 'tap-to-play');
    const customEvent = new CustomEvent('play-btn-clicked');
    const customEventAnalytic = new CustomEvent('analytic-play-btn-clicked');
    if (playBtn) {
        playBtn.addEventListener("pointerup", (e) => {
            window.dispatchEvent(customEvent)
            window.dispatchEvent(customEventAnalytic)
        });
    }

    const repeatTutorialBtn = tempDiv.querySelector('#' + 'repeat-tutorial');
    if (repeatTutorialBtn) {
        repeatTutorialBtn.addEventListener("pointerup", (e) => {
            e.preventDefault();
            const customEvent = new CustomEvent('repeat-tutorial');
            window.dispatchEvent(customEvent)
        });
    }



    document.body.appendChild(tempDiv)
    if (locObject && locObject['game-goal-play'] && tempDiv.querySelector('#tap-to-play')) {
        tempDiv.querySelector('#tap-to-play').textContent = locObject['game-goal-play'];
    }
    if (locObject && locObject['game-goal-repeat-tutorial'] && tempDiv.querySelector('#repeat-tutorial')) {
        tempDiv.querySelector('#repeat-tutorial').textContent = locObject['game-goal-repeat-tutorial'];
    }
    if (locObject && locObject['game-goal-goal'] && tempDiv.querySelector('#game-goal-goal')) {
        tempDiv.querySelector('#game-goal-goal').textContent = locObject['game-goal-goal'];
    }
    if (locObject && locObject['game-goal-description'] && tempDiv.querySelector('#game-goal-task-description')) {
        tempDiv.querySelector('#game-goal-task-description').innerHTML = locObject['game-goal-description'];
    }
    if (data.quiz && tempDiv.querySelector('#game-goal-task-description')) {
        tempDiv.querySelector('#game-goal-task-description').innerHTML = 'Play the quiz and claim your prize.<br>Need help?';
    }
    return tempDiv;
}

// используется (match, bubble, 2d)
window.getLoader = function (isShowLogo, isShowLoaderBack, logoUrl) {
    const DEFAULT_LOGO_URL = 'https://d43xjjq7uepv7.cloudfront.net/general-popups/assets/img/winday-logo-loading.png';
    const popup = getPopupByName('loader');
    const tempDiv = document.createElement('div');

    tempDiv.innerHTML = popup;

    if (isShowLoaderBack) {
        tempDiv.querySelector('#loader_back').style.display = 'block';
    }

    const logoImg = tempDiv.querySelector('.loader-logo img');
    if (logoImg) {
        logoImg.src = logoUrl || DEFAULT_LOGO_URL;
    }

    tempDiv.querySelector('.loader-logo').style.display = isShowLogo ? 'block' : 'none';

    return tempDiv;
}

// используется (match)
window.getLandscapeMode = function (locObject) {
    const popup = getPopupByName('landscape-mode');
    const tempDiv = document.createElement('div');

    tempDiv.innerHTML = popup;

    if (locObject && locObject['orientation-popup-vertical-orientation-only']) {
        tempDiv.querySelector('#landscape__title').textContent = locObject['orientation-popup-vertical-orientation-only'];
    }
    if (locObject && locObject['orientation-popup-game-type-not-support']) {
        tempDiv.querySelector('#landscape__text').innerHTML = locObject['orientation-popup-game-type-not-support'];
    }
    return tempDiv;
}

// используется (match)
window.getResultNotSave = function (locObject) {
    const popup = getPopupByName('result-not-save');
    const tempDiv = document.createElement('div');

    tempDiv.innerHTML = popup;

    const btnPlayAgain = tempDiv.querySelector('#' + 'play-again');
    const playAgainCustomEvent = new CustomEvent('play-again-btn-clicked');
    btnPlayAgain.addEventListener("pointerup", (e) => {
        window.dispatchEvent(playAgainCustomEvent)
        tempDiv.parentElement.removeChild(tempDiv);
    });

    const btnExit = tempDiv.querySelector('#' + 'exit-game');
    const exitCustomEvent = new CustomEvent('exit-btn-clicked');
    btnExit.addEventListener("pointerup", (e) => {
        window.dispatchEvent(exitCustomEvent)
        tempDiv.parentElement.removeChild(tempDiv);
    });

    if (locObject && locObject['result-not-save-title']) {
        tempDiv.querySelector('#modal__title').innerHTML = locObject['result-not-save-title'];
    }
    if (locObject && locObject['result-not-save-exit']) {
        tempDiv.querySelector('#exit-game').textContent = locObject['result-not-save-exit'];
    }
    if (locObject && locObject['result-not-save-description']) {
        tempDiv.querySelector('#modal__text').textContent = locObject['result-not-save-description'];
    }
    if (locObject && locObject['result-not-save-play-again']) {
        tempDiv.querySelector('#play-again').textContent = locObject['result-not-save-play-again'];
    }
    
    return tempDiv;
}

// используется (match, bubble, 2d)
window.getPreviewPopup = function (logoUrl, locObject) {
    
    if (!logoUrl) {
        logoUrl = 'https://via.placeholder.com/100';
    }
    const popup = getPopupByName('preview');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = popup;
    const targetNameEl = tempDiv.querySelector('.logo');
    if (popup && logoUrl && targetNameEl) {
        console.log(targetNameEl);
        targetNameEl.src = logoUrl;
    }
    if (tempDiv.querySelector('#Button55')) {
        tempDiv.querySelector('#Button55').addEventListener(('pointerup'), () => {
            const customEvent = new CustomEvent('play-again-btn-clicked');
            window.dispatchEvent(customEvent)
        })
    }

    if (locObject && locObject['preview-title']) {
        tempDiv.querySelector('#modal__title').textContent = locObject['preview-title'];
    }
    if (locObject && locObject['preview-description']) {
        tempDiv.querySelector('#modal__text').textContent = locObject['preview-description'];
    }
    if (locObject && locObject['preview-play-again']) {
        tempDiv.querySelector('#Button55').textContent = locObject['preview-play-again'];
    }
    return tempDiv;
}

// используется (match, bubble, 2d)
window.getOopsPopup = function (isHideExit = true, locObject) {
    const popup = getPopupByName('oops');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = popup;
    const customEvent = new CustomEvent('play-again-btn-clicked');
    tempDiv.querySelector('#error-btn').addEventListener('pointerup', () => {
        window.dispatchEvent(customEvent)
    });

    if (locObject && locObject['oops-title']) {
        tempDiv.querySelector('#modal__title').innerHTML = locObject['oops-title'];
    }
    if (locObject && locObject['bad-internet-btn']) {
        tempDiv.querySelector('#error-btn').textContent = locObject['bad-internet-btn'];
    }
    if (locObject && locObject['oops-description']) {
        tempDiv.querySelector('#modal__text').textContent = locObject['oops-description'];
    }

    if (isHideExit) {
        tempDiv.querySelector('#error-btn_container').style.display = 'none';
    }

    return tempDiv;
}

// используется (match, bubble, 2d)
window.getConfirmExitPopup = function (locObject) {
    console.log('getConfirmExitPopup');
    
    const popup = getPopupByName('confirm-exit');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = popup;
    const customEvent = new CustomEvent('exit-btn-clicked');
    tempDiv.querySelector('#error-btn').addEventListener('pointerup', () => {
        tempDiv.remove();
        window.dispatchEvent(customEvent)
    });

    const btnResume = tempDiv.querySelector('#' + 'resume-game');
    const resumeCustomEvent = new CustomEvent('resume-btn-clicked');
    btnResume.addEventListener("pointerup", (e) => {
        window.dispatchEvent(resumeCustomEvent)
    });

    if (locObject && locObject['confirm-exit-title'] && tempDiv.querySelector('#confirm-exit-title')) {
        tempDiv.querySelector('#confirm-exit-title').innerHTML = locObject['confirm-exit-title'];
    }
    if (locObject && locObject['confirm-exit-description'] && tempDiv.querySelector('#leave')) {
        tempDiv.querySelector('#leave').textContent = locObject['confirm-exit-description'];
    }
    if (locObject && locObject['confirm-exit-if-you-exit'] && tempDiv.querySelector('#confirm-exit-if-you-exit')) {
        tempDiv.querySelector('#confirm-exit-if-you-exit').textContent = locObject['confirm-exit-if-you-exit'];
    }
    if (locObject && locObject['confirm-exit-exit'] && tempDiv.querySelector('#error-btn')) {
        tempDiv.querySelector('#error-btn').textContent = locObject['confirm-exit-exit'];
    }
    if (locObject && locObject['confirm-exit-resume'] && tempDiv.querySelector('#resume-game')) {
        tempDiv.querySelector('#resume-game').textContent = locObject['confirm-exit-resume'];
    }

    return tempDiv;
}

// используется (match, bubble, 2d)
window.getTournamentGameGoal = function(data, locObject) {
    // data keys: 
    // gameName: string = game nage
    // gameIcon?: string = game icon (optional)
    // targetText: string

    if (!data.gameName) {
        throw new Error('"gameName" is required');
    }

    if (!data.targetText) {
        throw new Error('"targetText" is required');
    }

    const popup = getPopupByName('tournament-game-goal');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = popup;

    const gameIconEl = tempDiv.querySelector('#game_icon');
    if (popup && data.gameIcon && gameIconEl) {
        gameIconEl.src = data.gameIcon;
    }

    const gameNameEl = tempDiv.getElementsByClassName('long-game-name')[0];
    if (gameNameEl) {
        gameNameEl.textContent = data.gameName;
    }

    const pointsTaskEl = tempDiv.getElementsByClassName('points-task')[0];
    if (pointsTaskEl) {
        pointsTaskEl.textContent = data.targetText;
    }

    const playBtn = tempDiv.querySelector('#' + 'tap-to-play');
    const customEvent = new CustomEvent('play-btn-clicked');
    const customEventAnalytic = new CustomEvent('analytic-play-btn-clicked');

    if (playBtn) {
        playBtn.addEventListener("pointerup", (e) => {
            window.dispatchEvent(customEvent)
            window.dispatchEvent(customEventAnalytic)
        });
    }

    const repeatTutorialBtn = tempDiv.querySelector('#' + 'repeat-tutorial');
    if (repeatTutorialBtn) {
        repeatTutorialBtn.addEventListener("pointerup", (e) => {
            e.preventDefault();
            const customEvent = new CustomEvent('repeat-tutorial');
            window.dispatchEvent(customEvent)
        });
    }

    if (locObject && locObject['game-goal-play'] && tempDiv.querySelector('#tap-to-play')) {
        tempDiv.querySelector('#tap-to-play').textContent = locObject['game-goal-play'];
    }
    if (locObject && locObject['game-goal-repeat-tutorial'] && tempDiv.querySelector('#repeat-tutorial')) {
        tempDiv.querySelector('#repeat-tutorial').textContent = locObject['game-goal-repeat-tutorial'];
    }
    if (locObject && locObject['game-goal-goal'] && tempDiv.querySelector('#game-goal-goal')) {
        tempDiv.querySelector('#game-goal-goal').textContent = locObject['game-goal-goal'];
    }
    if (locObject && locObject['game-goal-description'] && tempDiv.querySelector('#game-goal-task-description')) {
        tempDiv.querySelector('#game-goal-task-description').innerHTML = locObject['game-goal-description'];
    }

    return tempDiv;
}

// используется
window.changeLoaderPercent = function(newPercent) {
    if (newPercent < 0) {
        newPercent = 0;
    }
    
    // Сохраняем ссылки на DOM-элементы один раз
    const percentDiv  = document.getElementById('loading-persent');
    const outerPath   = document.querySelector('#outer  path');
    const innerPath   = document.querySelector('#inner  path');
    if (!outerPath || !innerPath) {
        return;
    }
    // Длина каждой окружности – это «100 %» пути
    const outerLen = outerPath.getTotalLength();
    const innerLen = innerPath.getTotalLength();

    // Готовим начальные стили: окружности полностью «пустые»
    [outerPath, innerPath].forEach((p, i) => {
    const len = i === 0 ? outerLen : innerLen;
    p.style.strokeDasharray  = len;
    p.style.strokeDashoffset = len;
    });

    // Главная функция, доступная снаружи
    window.changeLoaderPercent = function (newPercent) {
    if (!percentDiv) return;

    // Текущее значение, вырезаем из «25%» → 25
    let currentPercent = parseInt(percentDiv.textContent, 10) || 0;

    // Защита от откатов и лишних вызовов
    newPercent = Math.max(0, Math.min(100, newPercent));   // clamp 0-100
    if (newPercent <= currentPercent) return;

    const duration   = 500;                       // ms
    const startTime  = performance.now();

    // Кадровая анимация
    function animate(time) {
        const progress = Math.min((time - startTime) / duration, 1);
        const value    = Math.floor(
        currentPercent + (newPercent - currentPercent) * progress
        );

        // 1) Число
        percentDiv.textContent = `${value < 0 ? 0 : value}%`;

        // 2) Окружности
        const outerOffset = outerLen * (1 - value / 100);
        const innerOffset = innerLen * (1 - value / 100);
        outerPath.style.strokeDashoffset = outerOffset;
        innerPath.style.strokeDashoffset = innerOffset;

        if (progress < 1) requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
    };
}

window.getTournamentPause = function (data) {
    // data keys: 
    // targetText: string
    // currentScore: number
    // isPreview: boolean
    if (!data.currentScore && data.currentScore !== 0) {
        throw new Error('"currentScore" is required');
    }

    if (!data.targetText) {
        throw new Error('"targetText" is required');
    }
    const popup = getPopupByName('tournament-pause');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = popup;
    tempDiv.getElementsByClassName('pause-text')[0].textContent = data.targetText;
    tempDiv.getElementsByClassName('score')[0].textContent = data.currentScore;

    const exitBtn = tempDiv.querySelector('#exit-game');
    const playAgainBtn = tempDiv.querySelector('#play-again');
    const awareText = tempDiv.querySelector('.aware');
    if (data.isPreview){
        exitBtn.style.display = 'none';
        playAgainBtn.style.display = 'block';
        awareText.style.display = 'none';
    } else {
        exitBtn.style.display = 'block';
        playAgainBtn.style.display = 'none';
        awareText.style.display = 'block';
    }

    const btnPlayAgain = tempDiv.querySelector('#' + 'play-again');
    btnPlayAgain.classList.remove('hidden');
    const playAgainCustomEvent = new CustomEvent('play-again-btn-clicked');
    btnPlayAgain.addEventListener("pointerup", (e) => {
        window.dispatchEvent(playAgainCustomEvent)
        tempDiv.parentElement.removeChild(tempDiv);
    });

    const btnExit = tempDiv.querySelector('#' + 'exit-game');
    btnExit.classList.remove('hidden');
    const exitCustomEvent = new CustomEvent('exit-btn-clicked');
    btnExit.addEventListener("pointerup", (e) => {
        window.dispatchEvent(exitCustomEvent)
        tempDiv.parentElement.removeChild(tempDiv);
    });

    const btnResume = tempDiv.querySelector('#' + 'resume-game');
    btnResume.classList.remove('hidden');
    const resumeCustomEvent = new CustomEvent('resume-btn-clicked');
    btnResume.addEventListener("pointerup", (e) => {
        window.dispatchEvent(resumeCustomEvent)
    });

    return tempDiv;
}

function renderNextBubbles(root, bubbles) {
    if (!root) {
        return;
    }

    const block = root.querySelector('#header_next_bubles');
    const container = root.querySelector('#header_next_bubles_container');

    if (!block || !container) {
        return;
    }

    const urls = (bubbles || [])
        .map((bubble) => typeof bubble === 'string' ? bubble : (bubble && bubble.url))
        .filter((url) => !!url);

    container.innerHTML = '';

    urls.forEach((url) => {
        const item = document.createElement('div');
        item.className = 'next_buble_item';

        const img = document.createElement('img');
        img.src = url.replace(/{{ASSETS}}/g, getBaseUrl() + 'assets/img/');
        img.alt = 'next_buble';

        item.appendChild(img);
        container.appendChild(item);
    });

    block.classList.toggle('header_hidden', urls.length === 0);
}

function toggleHidden(root, id, hidden) {
    const el = root.querySelector('#' + id);

    if (el) {
        el.classList.toggle('header_hidden', hidden);
    }
}

function applyQuizState(root, quiz) {
    if (!root) {
        return;
    }

    const header = root.querySelector('#game_header');

    if (!header) {
        return;
    }

    header.classList.remove('fortune_wheel');
    toggleHidden(root, 'header_fortune_hex', true);

    if (!quiz) {
        header.classList.remove('quiz_no_timer');
        toggleHidden(root, 'header_quiz', true);
        toggleHidden(root, 'header_allowed_mistakes', true);
        toggleHidden(root, 'header_hex', false);
        toggleHidden(root, 'header_goal', false);
        toggleHidden(root, 'header_score', false);

        return;
    }

    const data = typeof quiz === 'object' ? quiz : {};
    const withTimer = data.timer !== false;

    header.classList.toggle('quiz_no_timer', !withTimer);
    toggleHidden(root, 'header_quiz', false);
    toggleHidden(root, 'header_hex', !withTimer);
    toggleHidden(root, 'header_goal', true);
    toggleHidden(root, 'header_score', true);

    const title = root.querySelector('#header_quiz_title');

    if (title && data.title) {
        title.textContent = data.title;
    }

    const text = root.querySelector('#header_quiz_text');

    if (text && data.text) {
        text.textContent = data.text;
    }

    const hasMistakes = data.mistakes !== undefined && data.mistakes !== null;
    const mistakesValue = root.querySelector('#header_allowed_mistakes_value');

    if (mistakesValue && hasMistakes) {
        mistakesValue.textContent = data.mistakes;
    }

    toggleHidden(root, 'header_allowed_mistakes', !hasMistakes);
}

function applyFortuneState(root, fortune) {
    if (!root) {
        return;
    }

    const header = root.querySelector('#game_header');

    if (!header) {
        return;
    }

    if (!fortune) {
        if (header.classList.contains('fortune_wheel')) {
            header.classList.remove('fortune_wheel');
            toggleHidden(root, 'header_fortune_hex', true);
            toggleHidden(root, 'header_hex', false);
            toggleHidden(root, 'header_goal', false);
            toggleHidden(root, 'header_score', false);
        }

        return;
    }

    const data = typeof fortune === 'object' ? fortune : {};

    header.classList.remove('quiz_no_timer');
    header.classList.add('fortune_wheel');
    toggleHidden(root, 'header_fortune_hex', false);
    toggleHidden(root, 'header_hex', true);
    toggleHidden(root, 'header_goal', true);
    toggleHidden(root, 'header_score', true);
    toggleHidden(root, 'header_quiz', true);
    toggleHidden(root, 'header_allowed_mistakes', true);

    const title = root.querySelector('#header_fortune_hex_title');

    if (title && data.title) {
        title.textContent = data.title;
    }

    const value = root.querySelector('#header_fortune_hex_value');

    if (value && data.spins !== undefined && data.spins !== null) {
        value.textContent = data.spins;
    }
}

// используется
window.getGameHeader = function (locObject, nextBubbles, quiz, fortune) {
    const popup = getPopupByName('game-header');

    if (!popup) {
        return null;
    }

    const tempDiv = document.createElement('div');
    tempDiv.style.zIndex = '99999';
    tempDiv.innerHTML = popup.replace(/{{ASSETS}}/g, getBaseUrl() + 'assets/img/');

    if (locObject) {
        const labels = {
            'header_hex_label': 'game-time',
            'header_score_label': 'game-score',
            'header_booster_label': 'booster',
            'header_next_bubles_title': 'next-bubbles'
        };

        for (const id in labels) {
            const text = locObject[labels[id]];
            const element = tempDiv.querySelector('#' + id);

            if (text && element) {
                element.textContent = text;
            }
        }
    }

    renderNextBubbles(tempDiv, nextBubbles);
    applyQuizState(tempDiv, quiz);

    if (fortune) {
        applyFortuneState(tempDiv, fortune);
    }

    return tempDiv;
}

// используется
window.setGameHeaderNextBubbles = function (nextBubbles) {
    renderNextBubbles(document, nextBubbles);
}

// используется
window.setGameHeaderQuizState = function (quiz) {
    applyQuizState(document, quiz);
}

// используется
window.setGameHeaderFortuneState = function (fortune) {
    applyFortuneState(document, fortune);
}

// window.addEventListener('play-again-btn-clicked', () => {
//     // do something
//  })

// const gameGoalPopup = window.getPausePopup(
//     {
//         targetText: 'test text',
//         isPreview: false,
//         destroyOrders: 
//             {target: 22, urls: ['https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg']}
//     });
// document.body.appendChild(gameGoalPopup);

// const gameGoalPopup = window.getGameGoalPopup(
//     {
//         gameName: 'test',
//         gameIcon: 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg',
//         targetText: 'test text',
//         destroyOrders: 
//             {target: 22, urls: ['https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg']}
//     });
// document.body.appendChild(gameGoalPopup);

// document.body.appendChild(window.getPreviewPopup('https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg'))


// const gameGoalPopup = window.getGameGoalPopup(
//     {
//         gameName: 'test',
//         gameIcon: 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg',
//         targetText: 'Destroy targets in the order.',
//         targets: [
//             {url: 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', target: 98199},
//             {url: 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', target: 98199},
//             {url: 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', target: 98199},
//             {url: 'https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg', target: 98199},
//         ]
//     });
// document.body.appendChild(gameGoalPopup);
// document.body.appendChild(window.getPreviewPopup('https://cdn.pixabay.com/photo/2019/08/09/13/51/boat-4395122_1280.jpg'))
// const popup = window.getLoader(false, true);
// document.body.appendChild(popup);
// window.changeLoaderPercent(percent);